import React, { FC } from "react";
import { Card, Modal } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { GET_PROJECT } from "../../graphql/queries";
import { useLocalState } from "../../graphql/hooks";
import { ProjectData, Revision } from "../../models/types";
import { getEnvironmentTag } from "../../common/Helpers";
import { CopyButton } from "../buttons/CopyButton";

interface Props {
    show: boolean;
    onClose: () => void;
    revision: Revision;
}

export const ProjectDetailsModal: FC<Props> = ({ show, onClose, revision }) => {
    const { useDarkMode } = useLocalState();
    const { data: { project } = {} } = useQuery<ProjectData>(GET_PROJECT, {
        variables: {
            projectId: Number(revision.project.id)
        }
    });

    if (!project) {
        return null;
    }

    const gitLink =
        "https://git.seepiagames.com/playableads/" + project.gitProjectName;
    const sshClone =
        "git clone --recursive -b " +
        project.gitProjectBranch +
        " ssh://git@git.seepiagames.com:2222/playableads/" +
        project.gitProjectName +
        ".git";
    const cliCommand = `seepia-cli ${getEnvironmentTag()}-i ${revision.id}`;

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="xl"
            keyboard={true}
            className={useDarkMode ? "modal-dark" : ""}
        >
            <Modal.Header closeButton>
                <Modal.Title>{project.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Card className="mb-2 mx-2">
                    <Card.Header>Basic info</Card.Header>
                    <Card.Body>
                        <Card.Title as="h6">Product name</Card.Title>
                        <Card.Text>{project.product?.name}</Card.Text>
                        <Card.Title as="h6">Product id</Card.Title>
                        <Card.Text>{project.product?.id}</Card.Text>
                        <Card.Title as="h6">Project name</Card.Title>
                        <Card.Text>{project.name}</Card.Text>
                        <Card.Title as="h6">Project id</Card.Title>
                        <Card.Text>{project.id}</Card.Text>
                        <Card.Title as="h6">Revision name</Card.Title>
                        <Card.Text>{revision.name}</Card.Text>
                        <Card.Title as="h6">Revision id</Card.Title>
                        <Card.Text>{revision.id}</Card.Text>
                        <Card.Title as="h6">Git project name</Card.Title>
                        <Card.Text>{project.gitProjectName}</Card.Text>
                        <Card.Title as="h6">Git project id</Card.Title>
                        <Card.Text>{project.gitProjectId}</Card.Text>
                        <Card.Title as="h6">Git project branch</Card.Title>
                        <Card.Text>{project.gitProjectBranch}</Card.Text>
                        <Card.Title as="h6">Source repository</Card.Title>
                        <Card.Text>
                            <a href={gitLink} target="_blank noopener noreffer">
                                {gitLink}
                            </a>
                        </Card.Text>
                    </Card.Body>
                </Card>
                <Card className="mb-2 mx-2">
                    <Card.Header>
                        Git clone url
                        <CopyButton value={sshClone} />
                    </Card.Header>
                    <Card.Body>
                        <code>{sshClone}</code>
                    </Card.Body>
                </Card>
                <Card className="mb-2 mx-2">
                    <Card.Header>
                        Seepia cli init command
                        <CopyButton value={cliCommand} />
                    </Card.Header>
                    <Card.Body>
                        <code>{cliCommand}</code>
                    </Card.Body>
                </Card>
            </Modal.Body>
        </Modal>
    );
};
